/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="91.33"
        height="95.61"
        viewBox="0 0 91.33 95.61"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="m79.83 51.14-23.4 22.75H6.9a6.65 6.65 0 1 0-.51 13.29h52.83a6.62 6.62 0 0 0 4.68-1.86l25.44-24.76a6.59 6.59 0 0 0 .19-9.24l-.18-.19a6.83 6.83 0 0 0-9.52.01Zm7.76 1.79a4.1 4.1 0 0 1 .07 5.8l-.07.06L62.17 83.5a4.09 4.09 0 0 1-2.93 1.15H6.9a4.15 4.15 0 1 1-.4-8.29h50.4a1.25 1.25 0 0 0 .88-.36l23.79-23.07a4.33 4.33 0 0 1 5.85-.16Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M18.91 84.89a1.25 1.25 0 0 1 1.48 2l-.11.08-12.27 8a1.25 1.25 0 0 1-1.48-2l.11-.08ZM47.75 85.18a1.25 1.25 0 0 1 1.64-.32l.11.08 11.07 8.4a1.25 1.25 0 0 1-1.4 2.07l-.12-.08-11.06-8.4a1.26 1.26 0 0 1-.24-1.75Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M33.55 19.55a9.44 9.44 0 1 0 9.44 9.44 9.44 9.44 0 0 0-9.44-9.44Zm0 2.5A6.94 6.94 0 1 1 26.62 29a6.94 6.94 0 0 1 6.93-6.95ZM33.55 0a1.26 1.26 0 0 1 1.25 1.12v10.92a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.09V1.25A1.25 1.25 0 0 1 33.55 0ZM33.55 44.68a1.26 1.26 0 0 1 1.25 1.12v10.92a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.09V45.93a1.25 1.25 0 0 1 1.24-1.25ZM52.28 8.5a1.26 1.26 0 1 1 1.89 1.66l-.09.1-7.63 7.63a1.25 1.25 0 0 1-1.86-1.67l.09-.1ZM20.69 40.08a1.25 1.25 0 0 1 1.77 0 1.25 1.25 0 0 1 .09 1.67l-.09.1-7.64 7.65a1.243 1.243 0 0 1-1.85-1.66l.09-.1ZM61.29 27.74a1.25 1.25 0 0 1 1.23 1.27 1.27 1.27 0 0 1-1.1 1.22H50.5a1.25 1.25 0 0 1-1.31-1.19 1.24 1.24 0 0 1 1.18-1.31h10.92ZM16.61 27.74a1.25 1.25 0 0 1 1.23 1.27 1.27 1.27 0 0 1-1.1 1.22H5.82a1.25 1.25 0 0 1-1.31-1.19 1.24 1.24 0 0 1 1.18-1.31h10.92ZM44.65 40.08a1.26 1.26 0 0 1 1.67-.09l.1.09 7.63 7.64a1.23 1.23 0 0 1 0 1.76 1.25 1.25 0 0 1-1.62.09l-.1-.09-7.63-7.63a1.25 1.25 0 0 1 0-1.77ZM13.06 8.5a1.22 1.22 0 0 1 1.66-.09l.1.09 7.64 7.63a1.24 1.24 0 0 1 .07 1.76 1.25 1.25 0 0 1-1.74.1l-.1-.09-7.63-7.63a1.25 1.25 0 0 1 0-1.77Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'BeachChairWithSunIcon';

export default Icon;
